import React, {useEffect} from "react";
import "./style.less"
import {List} from "antd";
import {Controls, Edge, MarkerType, Node, ReactFlow, ReactFlowProvider, useReactFlow} from '@xyflow/react';
import '@xyflow/react/dist/style.css';
import {PageHeader} from "@ant-design/pro-layout";
import {navigateBackHandler} from "../../helpers/mainHelpers";
import SuccessButton from "../../components/main-buttons/success-button/SuccessButton";
import {DownloadOutlined} from "@ant-design/icons";
import {useUploadController} from "../../controllers/upload-controller";
import EmployeeDetailModal from "../administratioin-page/components/detail-modal/DetailModal";
import useEmployeeController from "../../controllers/employee-controller";
import {EMPLOYEE_IDS} from "../../enums/employeeIds";
import {DEPARTMENTS_IDS} from "../../enums/departmentsIds";
import {useDevice} from "../../context/deviceContext";

const NODE_TYPES = {
  EMPLOYEE: "employee",
  DEPARTMENT: "department"
}


const X_GRID_STEP = 155;
const Y_GRID_STEP = 100;


const StructureFlow = (props: { nodes: Node[], edges: Edge[] }) => {
  const {nodes, edges} = props
  const {fitView} = useReactFlow();
  const employeeController = useEmployeeController()
  const {getEmployeeData, toggleDetailModal} = employeeController


  const openDepartmentPage = (departmentId: string) => {
    window.open(`https://blyznuky-crl.com.ua/department/${departmentId}`, "_blank", "noopener,noreferrer");
  }

  const handleNodeClick = async (event: React.MouseEvent, node: Node) => {
    // @ts-ignore
    if (node?.additionalData?.type === NODE_TYPES.EMPLOYEE && node?.additionalData?.id) {
      // @ts-ignore
      const employeeId = node?.additionalData?.id as string
      await getEmployeeData(employeeId)
      toggleDetailModal()
    }
    // @ts-ignore
    if (node?.additionalData?.type === NODE_TYPES.DEPARTMENT && node?.additionalData?.id) {
      // @ts-ignore
      const departmentId = node?.additionalData?.id as string
      openDepartmentPage(departmentId)
    }
  };


  useEffect(() => {
    const timeout = setTimeout(() => {
      fitView();
    }, 100);

    return () => clearTimeout(timeout);
  }, [fitView]);

  return (
    <ReactFlow onNodeClick={handleNodeClick} className="structure_component" nodes={nodes} edges={edges} nodesDraggable>
      <Controls/>
      {employeeController.isDetailModalOpen && <EmployeeDetailModal employeeController={employeeController}/>}

    </ReactFlow>
  );
};


function StructurePage() {
  const {downloadFileHandler} = useUploadController()
  const {isMobile} = useDevice()


  const downloadButtonHandler = () => {
    const STRUCTURE_FILE_ID = "67f10b2a000934e74be1"
    downloadFileHandler(STRUCTURE_FILE_ID)

  }

  const subItems = [
    {
      id: "2.9", data: [
        {id: "2.9_a", label: "Кабінет лікаря терапевта;"},
        {id: "2.9_b", label: "Кабінет лікаря педіатра;"},
        {id: "2.9_c", label: "Амбулаторія ЗПСМ с.Уплатне"},
        {id: "2.9_d", label: "Амбулаторія ЗПСМ с.Самійлівка"},
        {id: "2.9_у", label: "Амбулаторія ЗПСМ с.В.Самара"},
      ]
    },
    {
      id: "2.10", data: [
        {id: "2.10_a", label: "Реєстратура"},
        {id: "2.10_b", label: "Процедурний кабінет"},
        {id: "2.10_c", label: "Долікарський кабінет"},
        {id: "2.10_x", label: "Кабінети:"},
        {id: "2.10_d", label: "- профілактичних щеплень"},
        {id: "2.10_e", label: "- лікаря-єндокринолога"},
        {id: "2.10_f", label: "- лікаря-хірурга"},
        {id: "2.10_g", label: "- лікаря-трансфузіолога"},
        {id: "2.10_h", label: "- Жіноча консультація"},
        {id: "2.10_i", label: "- лікаря-уролога"},
        {id: "2.10_j", label: "- лікаря-отоларинголога"},
        {id: "2.10_k", label: "- лікаря-офтальмолога"},
        {id: "2.10_l", label: "- лікаря-невропатолога"},
        {id: "2.10_m", label: "- лікаря-стоматолога"},
        {id: "2.10_n", label: "- інфекційних захворювань"},
        {id: "2.10_o", label: "- лікаря-ортопеда-травматолога"},
      ]
    },
    {
      id: "2.8.1", data: [
        {id: "2.8.1_a", label: "Рентгенологічний кабінет"},
        {id: "2.8.1_b", label: "Комп'ютерна томографія (КТ)"},
        {id: "2.8.1_c", label: "Кабінет ультразвукової діагностики (УЗД)"},

      ]
    },
  ]

  const renderItem = (title: string, id: string) => {
    const listData = subItems.find(item => item.id === id)
    return <div>
      <div>{title}</div>
      {listData &&
          <List key={title} style={{borderTop: "1px solid black", width: "100%", marginTop: "3px"}} size="small">{
            listData.data.map(data => <List.Item>{data?.label}</List.Item>)
          }</List>}
    </div>
  }


  const getPosition = (col: number, row: number) => ({
    x: col * X_GRID_STEP,
    y: row * Y_GRID_STEP,
  });


  const initialNodes = [
    // Генеральний директор branch
    {
      id: '1',
      position: getPosition(5, 0),
      source: 'center',
      data: {label: 'Генеральний директор'},
      draggable: false,
      additionalData: {type: NODE_TYPES.EMPLOYEE, id: EMPLOYEE_IDS.GENERAL_MANAGER},
      className: "employee_node"
    },
    {
      id: "12",
      position: getPosition(0.5, 1),
      data: {label: "Відділ інфекційного контролю (ВІК)"},
      draggable: true,
      className: "inactive_node"
    },
    {
      id: "15",
      position: getPosition(1.5, 1),
      data: {label: renderItem("Інформаційно аналітичний відділ", "15")},
      draggable: true,
      className: "inactive_node"
    },
    {
      id: "13",
      position: getPosition(2.5, 1),
      data: {label: "Головний бухгалтер"},
      additionalData: {type: NODE_TYPES.EMPLOYEE, id: EMPLOYEE_IDS.CHIEF_ACCOUNTANT},
      draggable: true,
      className: "employee_node"
    },
    {
      id: "10",
      position: getPosition(3.5, 1),
      data: {label: "Працівники апарату управління"},
      draggable: true,
      className: "inactive_node"
    },
    {
      id: "5",
      position: getPosition(6.3, 1),
      data: {label: "Заступник генерального директора з медичного обслуговування населення"},
      additionalData: {type: NODE_TYPES.EMPLOYEE, id: EMPLOYEE_IDS.INTERCESSOR},
      className: "employee_node"
    },
    {
      id: "4",
      position: getPosition(7.3, 1),
      data: {label: "Господарсько-обслуговуючий персонал"},
      draggable: true,
      className: "inactive_node"
    },

    {
      id: "8",
      position: getPosition(8.3, 1),
      data: {label: "Загальнолікарняний персонал"},
      draggable: true,
      className: "inactive_node"
    },


    {
      id: "33",
      position: getPosition(2.5, 2),
      data: {label: "Бухгалтерія"},
      draggable: true,
      className: "inactive_node"
    },
    // Медичний директор branch
    {
      id: '2',
      position: getPosition(5, 2),
      data: {label: 'Медичний директор'},
      additionalData: {type: NODE_TYPES.EMPLOYEE, id: EMPLOYEE_IDS.MEDICAL_MANAGER},
      className: "employee_node"
    },
    {
      id: '19',
      position: getPosition(5, 3),
      data: {label: 'Пункт невідкладної медичної допомоги'},
      additionalData: {type: NODE_TYPES.DEPARTMENT, id: DEPARTMENTS_IDS.EMERGENCY},
      className: "department_node"
    },
    {
      id: '2.2',
      position: getPosition(1, 3),
      data: {label: 'Загальнотерапевтичне відділення'},
      additionalData: {type: NODE_TYPES.DEPARTMENT, id: DEPARTMENTS_IDS.GENERAL_THERAPY},
      className: "department_node"
    },
    {
      id: '2.3',
      position: getPosition(2, 3),
      data: {label: 'Неврологічне відділення'},
      additionalData: {type: NODE_TYPES.DEPARTMENT, id: DEPARTMENTS_IDS.NEUROLOGICAL},
      className: "department_node"
    },
    {
      id: '2.4',
      position: getPosition(3, 3),
      data: {label: 'Загальнохірургічне відділення'},
      additionalData: {type: NODE_TYPES.DEPARTMENT, id: DEPARTMENTS_IDS.GENERAL_SURGICAL},
      className: "department_node"
    },
    {
      id: '2.5',
      position: getPosition(9, 3),
      data: {label: 'Відділення анестезіології та інтенсивної терапії'},
      className: "inactive_node"
    },
    {
      id: '2.6',
      position: getPosition(7, 3),
      data: {label: 'Відділення паліативної допомоги'},
      additionalData: {type: NODE_TYPES.DEPARTMENT, id: DEPARTMENTS_IDS.PALIATIVE},
      className: "department_node"
    },
    {
      id: '2.7',
      position: getPosition(6, 3),
      data: {label: 'Реабілітаційне відділення'},
      additionalData: {type: NODE_TYPES.DEPARTMENT, id: DEPARTMENTS_IDS.REHABILITATION},
      className: "department_node"
    },
    {
      id: '2.8',
      position: getPosition(4, 3),
      data: {label: 'Допоміжні лікувально-діагностичні підрозділи'},
      className: "inactive_node"
    },
    {
      id: '2.9',
      position: getPosition(0, 3),
      data: {
        label: renderItem('Відділення загальної практики сімейної медицини (ЗПСМ)', '2.9'),
      },
      additionalData: {type: NODE_TYPES.DEPARTMENT, id: DEPARTMENTS_IDS.FAMILY_MEDICINE},
      className: "department_node"
    },
    {
      id: '2.10',
      position: getPosition(10, 3),
      data: {label: renderItem('Поліклінічне відділення', '2.10')},
      additionalData: {type: NODE_TYPES.DEPARTMENT, id: DEPARTMENTS_IDS.POLYCLINIC},
      className: "department_node"
    },
    // 2.8 CHILDREN
    {
      id: '2.8.1',
      position: getPosition(1, 4.3),
      data: {label: renderItem('Відділення рентгенології', '2.8.1')},
      additionalData: {type: NODE_TYPES.DEPARTMENT, id: DEPARTMENTS_IDS.RADIOLOGY},
      className: "department_node"
    },
    {
      id: '2.8.2',
      position: getPosition(2, 4.3),
      data: {label: 'Клініко-діагностична лабораторія'},
      className: "inactive_node"
    },
    {id: '2.8.3', position: getPosition(3, 4.3), data: {label: 'Ендоскопічний кабінет'}, className: "inactive_node"},
    {
      id: '2.8.4',
      position: getPosition(4, 4.3),
      data: {label: 'Кабінет функціональної діагностики'},
      className: "inactive_node"
    },
    // Головна медична сестра BRANCH
    {
      id: '16',
      position: getPosition(8, 3),
      data: {label: 'Головна медична сестра'},
      additionalData: {type: NODE_TYPES.EMPLOYEE, id: EMPLOYEE_IDS.HEAD_NURSE},
      className: "employee_node"
    }, // +
    // 16 CHILDREN
    {
      id: '16.1',
      position: getPosition(9, 4.3),
      data: {label: renderItem('Молодші спеціалісти з медичною освітою, фахівці з реабілітації, робітники', "18")},
      className: "inactive_node"
    },
    {
      id: '16.2',
      position: getPosition(8, 4.3),
      data: {label: 'Централізована стерилізаційна'},
      className: "inactive_node"
    },
    {
      id: "16.3",
      position: getPosition(7, 4.3),
      data: {label: "Харчоблок"},
      draggable: true,
      className: "inactive_node"
    },
    {
      id: "16.4",
      position: getPosition(6, 4.3),
      data: {label: "Дезінфекційна камера"},
      draggable: true,
      className: "inactive_node"
    },

  ];
  const initialEdges = [
    {id: 'e1-2', source: '1', target: '2', type: 'smoothstep', markerEnd: {type: MarkerType.Arrow}},
    {id: 'e1-4', source: '1', target: '4', type: 'smoothstep', markerEnd: {type: MarkerType.Arrow}},
    {id: 'e1-5', source: '1', target: '5', type: 'smoothstep', markerEnd: {type: MarkerType.Arrow}},
    {id: 'e1-8', source: '1', target: '8', type: 'smoothstep', markerEnd: {type: MarkerType.Arrow}},
    {id: 'e1-10', source: '1', target: '10', type: 'smoothstep', markerEnd: {type: MarkerType.Arrow}},
    {id: 'e1-12', source: '1', target: '12', type: 'smoothstep', markerEnd: {type: MarkerType.Arrow}},
    {id: 'e1-13', source: '1', target: '13', type: 'smoothstep', markerEnd: {type: MarkerType.Arrow}},
    {id: 'e1-15', source: '1', target: '15', type: 'smoothstep', markerEnd: {type: MarkerType.Arrow}},
    {id: 'e2-16', source: '2', target: '16', type: 'smoothstep', markerEnd: {type: MarkerType.Arrow}},
    {id: 'e2-2.2', source: '2', target: '2.2', type: 'smoothstep', markerEnd: {type: MarkerType.Arrow}},
    {id: 'e2-2.3', source: '2', target: '2.3', type: 'smoothstep', markerEnd: {type: MarkerType.Arrow}},
    {id: 'e2-2.4', source: '2', target: '2.4', type: 'smoothstep', markerEnd: {type: MarkerType.Arrow}},
    {id: 'e2-2.5', source: '2', target: '2.5', type: 'smoothstep', markerEnd: {type: MarkerType.Arrow}},
    {id: 'e2-2.6', source: '2', target: '2.6', type: 'smoothstep', markerEnd: {type: MarkerType.Arrow}},
    {id: 'e2-2.7', source: '2', target: '2.7', type: 'smoothstep', markerEnd: {type: MarkerType.Arrow}},
    {id: 'e2-2.8', source: '2', target: '2.8', type: 'smoothstep', markerEnd: {type: MarkerType.Arrow}},
    {id: 'e2-2.9', source: '2', target: '2.9', type: 'smoothstep', markerEnd: {type: MarkerType.Arrow}},
    {id: 'e2-2.10', source: '2', target: '2.10', type: 'smoothstep', markerEnd: {type: MarkerType.Arrow}},
    {id: 'e2.8-2.8.1', source: '2.8', target: '2.8.1', type: 'smoothstep', markerEnd: {type: MarkerType.Arrow}},
    {id: 'e2.8-2.8.2', source: '2.8', target: '2.8.2', type: 'smoothstep', markerEnd: {type: MarkerType.Arrow}},
    {id: 'e2.8-2.8.3', source: '2.8', target: '2.8.3', type: 'smoothstep', markerEnd: {type: MarkerType.Arrow}},
    {id: 'e2.8-2.8.4', source: '2.8', target: '2.8.4', type: 'smoothstep', markerEnd: {type: MarkerType.Arrow}},
    {id: 'e16-16.1', source: '16', target: '16.1', type: 'smoothstep', markerEnd: {type: MarkerType.Arrow}},
    {id: 'e16-16.2', source: '16', target: '16.2', type: 'smoothstep', markerEnd: {type: MarkerType.Arrow}},
    {id: 'e16-16.3', source: '16', target: '16.3', type: 'smoothstep', markerEnd: {type: MarkerType.Arrow}},
    {id: 'e16-16.4', source: '16', target: '16.4', type: 'smoothstep', markerEnd: {type: MarkerType.Arrow}},
    {id: 'e2-19', source: '2', target: '19', type: 'smoothstep', markerEnd: {type: MarkerType.Arrow}},
    {id: 'e2-20', source: '2', target: '20', type: 'smoothstep', markerEnd: {type: MarkerType.Arrow}},
    {id: 'e2-21', source: '2', target: '21', type: 'smoothstep', markerEnd: {type: MarkerType.Arrow}},
    {id: 'e5-6', source: '5', target: '6', type: 'smoothstep', markerEnd: {type: MarkerType.Arrow}},
    {id: 'e13-33', source: '13', target: '33', type: 'smoothstep', markerEnd: {type: MarkerType.Arrow}},
  ];

  const downloadButtonTitle = isMobile ? undefined : 'Завантажити'
  return (
    <>
      <div className='page_title'>
        <PageHeader
          title={
            <div className="page-header_title">
              <div className="page_name">Структура підприємства</div>
            </div>
          }
          extra={[<SuccessButton onClick={downloadButtonHandler} icon={<DownloadOutlined/>}
                                 children={downloadButtonTitle}
                                 type={"default"}/>]}
          onBack={navigateBackHandler}
        />

        <div className="diagram_container">
          <ReactFlowProvider> <StructureFlow nodes={initialNodes} edges={initialEdges}/></ReactFlowProvider>
        </div>

      </div>
    </>
  );


}

export default StructurePage
